import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function relatorioTempoRespostaClassificacaoFaixaReducer(state = initialState.relatorioTempoRespostaClassificacaoFaixa, action){
    switch(action.type) {
        case types.RELAT_TEMPO_RESPOSTA_CLASSIFICACAO_FAIXA:
            
            return action.relatorioTempoRespostaClassificacaoFaixa;
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/reduces/relatorioTempoRespostaClassificacaoFaixaReducer.js
 **/